import { useEffect, type FC, type PropsWithChildren } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { TextButton } from '@xing-com/button';
import { GridContainer as InnerGridContainer, GridItem } from '@xing-com/grid';
import { IconArrowLeft } from '@xing-com/icons';
import { Headline, Meta } from '@xing-com/typography';

import { ROUTES } from '../../routes';
import { scrollToTop } from '../../utils';
import { MetaData } from '../meta-data';

const GridContainer = styled(InnerGridContainer)`
  max-width: 1520px;
  padding: 0;
`;

type SubpageLayoutProps = {
  headerText: string;
  description?: string;
};

export const SubpageLayout: FC<PropsWithChildren<SubpageLayoutProps>> = ({
  headerText,
  description,
  children,
}) => {
  useEffect(() => scrollToTop(), []);
  return (
    <GridContainer variant="LoggedOut">
      <MetaData
        index
        title={headerText}
        description={description ?? headerText}
      />
      <GridItem>
        <TextButton
          icon={IconArrowLeft}
          size="medium"
          sizeWide="large"
          to={ROUTES.companies}
        >
          <FormattedMessage id="VERTICAL_NAVIGATION_COMPANIES" />
        </TextButton>
      </GridItem>
      <GridItem spanLarge={6}>
        <Headline size="xxxlarge" as="h1">
          {headerText}
        </Headline>
        <Meta size="large">{description}</Meta>
      </GridItem>
      <GridItem>{children}</GridItem>
    </GridContainer>
  );
};
